import { render } from "./LightAlert.vue?vue&type=template&id=37c596cf"
import script from "./LightAlert.vue?vue&type=script&lang=js"
export * from "./LightAlert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thomas/Workspace/SushiEden/SushiEden.Admin.Vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__